module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tit1"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("Civil War Monuments")]), _vm._v(" "), _c('h1', {
    staticClass: "tit2"
  }, [_vm._v("and Memory")]), _vm._v(" "), _c('p', {
    staticClass: "stit1"
  }, [_vm._v("Favorite Stories and Fresh Perspectives")]), _vm._v(" "), _c('p', {
    staticClass: "stit1"
  }, [_vm._v("from the Historians at Emerging Civil War")]), _vm._v(" "), _c('p', {
    staticClass: "edi1"
  }, [_vm._v("Edited by")]), _vm._v(" "), _c('p', {
    staticClass: "edi2"
  }, [_vm._v("Jonathan Tracey & Chris Mackowski")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76de0eda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Title.vue
// module id = 63
// module chunks = 0